module.exports = __webpack_public_path__ + "images/checkbox-checked-33bc8abd.svg";